/**
 * Bid statuses (ticket #295)
 * Values match bids.status on the server (utils/bid-number.js); labels and
 * StatusPill tones are the client's. Order is the order shown in the Status
 * select.
 */
export const BID_STATUSES = [
  { value: 'estimating', label: 'Estimating', tone: 'info' },
  { value: 'submitted', label: 'Submitted', tone: 'warning' },
  { value: 'won', label: 'Won', tone: 'success' },
  { value: 'lost', label: 'Lost', tone: 'neutral' },
  { value: 'no_bid', label: 'No bid', tone: 'neutralOutline' },
  { value: 'cancelled', label: 'Cancelled', tone: 'neutralOutline' },
];

/**
 * Filter groups for the All bids "Show" chips and GET /api/bids?group=.
 * Same as STATUS_GROUPS on the server.
 */
export const STATUS_GROUPS = {
  open: ['estimating', 'submitted'],
  won: ['won'],
  closed: ['lost', 'no_bid', 'cancelled'],
  all: BID_STATUSES.map((status) => status.value),
};

const byValue = Object.fromEntries(
  BID_STATUSES.map((status) => [status.value, status])
);

/** Display label for a status value, e.g. 'no_bid' -> 'No bid'. */
export const statusLabel = (value) => byValue[value]?.label ?? value ?? '';

/** StatusPill tone for a status value; 'neutral' when unknown. */
export const statusTone = (value) => byValue[value]?.tone ?? 'neutral';
